export default __webpack_public_path__ + "static/media/icon-sort.f260c11e.svg";